<ng-container *ngIf="moveCodesLoading">
	<div class="text-center p-4">
		<i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
		<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_LOAD_MSG_MC'] }}</p>
	</div>
</ng-container>
<ng-container *ngIf="moveCodesError">
	<div class="text-center p-4">
		<i class="pi pi-exclamation-triangle text-danger" style="font-size: 2rem"></i>
		<p class="p-error mt-2">{{ translateServ.dictionary['MAINT_LOAD_FAILED_MSG_MC'] }}</p>
	</div>
</ng-container>
<ng-container *ngIf="!moveCodesLoading && !moveCodesError">
	<div class="horizontal-scroll">
		<div class="flex justify-between items-center mb-3 px-2">
			<!-- Left: Create New button -->
			<button pButton type="button" icon="pi pi-plus"
				label="{{ translateServ.dictionary['CREATE_NEW'] || 'Create New' }}"
				class="p-button-sm p-button-primary" (click)="createNewRecord()"></button>

			<!-- Right: Global filter -->
			<span class="p-input-icon-left">
				<i class="pi pi-search"></i>
				<input type="text" pInputText [(ngModel)]="globalFilter" (input)="applyGlobalFilter()"
					placeholder="{{ translateServ.dictionary['SEARCH'] || 'Search' }}"
					class="p-inputtext-sm" />
			</span>
		</div>
		<p-table 
			#dt 
			id = "tab_mc"
			[globalFilterFields]="globalFilterFields" 
			[value]="moveCodes"
			[totalRecords] = "moveCodes.length"
	      	dataKey="RecID"
			*ngIf="moveCodes && moveCodes.length > 0; else noMoveCodes" styleClass="app-data-table app-data-table--paged app-data-table--editable p-datatable-sm p-datatable-striped"
			responsiveLayout="scroll" 
			[paginator]="true"
			[rows]="getCurrentPageSize(0, moveCodes.length)" 
			[rowsPerPageOptions]="setPaginator(moveCodes.length)"
			(onPage) = "onRowsPerPageChange($event,0, moveCodes.length)"
			[showCurrentPageReport]="true"
			currentPageReportTemplate="{{ translateServ.dictionary['TAB_FOOTER_SHOWING'] }} {first} {{ translateServ.dictionary['TAB_FOOTER_TO'] }} {last} {{ translateServ.dictionary['TAB_FOOTER_OF'] }} {totalRecords} {{ translateServ.dictionary['MAINT_TABLE_MCS'] }}"
			[tableStyle]="{'min-width': '48rem', 'table-layout': 'auto'}" [paginatorDropdownAppendTo]="'body'">
			<ng-template let-item pTemplate="paginatordropdownitem">
				{{ item.value === moveCodes.length ? 'All' : item.value }}
			</ng-template>
			<ng-template pTemplate="header">
				<tr>
					<th pSortableColumn="RecID">
						{{ translateServ.dictionary['MAINT_CS_TIT_ID'] || 'ID' }}
						<p-sortIcon field="RecID"></p-sortIcon>
					</th>
					<th pSortableColumn="Type">
						{{ translateServ.dictionary['MAINT_IN_TIT_TYPE'] || 'Type' }}
						<p-sortIcon field="Type"></p-sortIcon>
					</th>
					<th pSortableColumn="IsActive">
						{{ translateServ.dictionary['STEP_TAB_TIT_ACT_STAT'] || 'Status' }}
						<p-sortIcon field="IsActive"></p-sortIcon>
					</th>
					<th pSortableColumn="IsApproved">
						{{ translateServ.dictionary['STEP_TAB_TIT_APPROVED'] || 'Approved' }}
						<p-sortIcon field="IsApproved"></p-sortIcon>
					</th>
					<th pSortableColumn="Descr">
						{{ translateServ.dictionary['STEP_TAB_TIT_DESC'] || 'Description' }}
						<p-sortIcon field="Descr"></p-sortIcon>
					</th>
					<th pSortableColumn="DateEntered">
						{{ translateServ.dictionary['MAINT_CS_TIT_DATE_ENTERED'] || 'Created On' }}
						<p-sortIcon field="DateEntered"></p-sortIcon>
					</th>
					<th pSortableColumn="DateUpdated">
						{{ translateServ.dictionary['MAINT_CS_TIT_DATE_UPDATED'] || 'Updated On' }}
						<p-sortIcon field="DateUpdated"></p-sortIcon>
					</th>
					<th>{{ translateServ.dictionary['MAINT_CS_TIT_ACTIONS'] || 'Actions' }}</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-moveCodeItem>
				<tr>
					<td>{{ moveCodeItem.RecID }}</td>
					<td>{{ moveCodeItem.CodeMoveType }}</td>

					<!-- Status -->
					<td>
						<p-tag
							[value]="moveCodeItem.IsActive === 1 ? (translateServ.dictionary['ACTIVE'] || 'Active') : (translateServ.dictionary['INACTIVE'] || 'Inactive')"
							[severity]="getMoveCodeSeverity(moveCodeItem.IsActive)"
							(click)="toggleMoveCodeStatus(moveCodeItem, true)">
						</p-tag>
					</td>

					<!-- Approved -->
					<td>
						<p-tag
							[value]="moveCodeItem.IsApproved === 1 ? (translateServ.dictionary['APPROVED'] || 'Approved') : (translateServ.dictionary['NOT_APPROVED'] || 'Not Approved')"
							[severity]="moveCodeItem.IsApproved === 1 ? 'success' : 'warning'"
							(click)="toggleMoveCodeStatus(moveCodeItem, false)">
						</p-tag>
					</td>

					<!-- Description with tooltip -->
					<td>
						<span *ngIf="moveCodeItem.Description; else noDescr" [pTooltip]="moveCodeItem.Description"
							tooltipPosition="top">
							{{ moveCodeItem.Description.length > 20 ? (moveCodeItem.Description | slice:0:20) + '…' :
							moveCodeItem.Description }}
						</span>
						<ng-template #noDescr>
							<span class="text-gray-400">—</span>
						</ng-template>
					</td>

					<!-- Dates -->
					<td>
						{{ moveCodeItem.DateEntered ? (moveCodeItem.DateEntered | date:'mediumDate') : 'N/A' }}
					</td>
					<td>
						{{ moveCodeItem.DateUpdated ? (moveCodeItem.DateUpdated | date:'mediumDate') : 'N/A' }}
					</td>

					<!-- Actions -->
					<td>
						<div class="flex gap-2">
							<button pButton icon="pi pi-pencil" (click)="editMoveCode(moveCodeItem)"
								class="p-button-rounded p-button-text p-button-sm"
								[pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']" tooltipPosition="top">
							</button>
							<button pButton icon="pi pi-trash" (click)="confirmDelete(moveCodeItem)"
								class="p-button-rounded p-button-text p-button-sm"
								[pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']" tooltipPosition="top">
							</button>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
	<ng-template #noMoveCodes>
		<div class="text-center p-4">
			<i class="pi pi-hashtag text-400" style="font-size: 3rem"></i>
			<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_NO_DATA_MSG_MC'] }}</p>
		</div>
	</ng-template>
</ng-container>